<ng-container *ngIf="!this.env.USE_TAILWIND; else elseBlock">
    <div class="block--content block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <div class="ticket" *ngIf="(accountDeletionEmailSuccess$ | async) === false">
                <rwidget-customer-account-detail-aside></rwidget-customer-account-detail-aside>
                <rwidget-customer-account-detail></rwidget-customer-account-detail>
            </div>
            <div class="ticket" *ngIf="accountDeletionEmailSuccess$ | async">
                <rwidget-email-sent
                    [title]="'ACCOUNT_DELETION_REQUEST_SENT_TITLE'"
                    [description]="'ACCOUNT_DELETION_REQUEST_SENT_DESCRIPTION'">
                </rwidget-email-sent>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #elseBlock>
    <div class="block--content-stw block" id="main-content">
        <div class="block--wrap block">
            <rwidget-alert></rwidget-alert>
            <div class="ticket-stw" *ngIf="(accountDeletionEmailSuccess$ | async) === false">
                <rwidget-customer-account-detail-stw></rwidget-customer-account-detail-stw>
                <div class="ticket-stw" *ngIf="accountDeletionEmailSuccess$ | async">
                    <rwidget-email-sent
                        [title]="'ACCOUNT_DELETION_REQUEST_SENT_TITLE'"
                        [description]="'ACCOUNT_DELETION_REQUEST_SENT_DESCRIPTION'">
                    </rwidget-email-sent>
                </div>
            </div>
        </div>
    </div>
</ng-template>
